/**
 * ModuleDoorAnimation enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file ModuleDoorAnimation.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum ModuleDoorAnimation {
  OPENING1  = 'opening1',
  OPENING2  = 'opening2',
  OPENED1   = 'opened1',
  OPENED2   = 'opened2',
  CLOSING1  = 'closing1',
  CLOSING2  = 'closing2',
  CLOSED    = 'closed',
  TRANS     = 'trans',
};